"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialIconYoutube = exports.SocialIconTwitter = exports.SocialIconLinkedIn = exports.SocialIconInstagram = exports.SocialIconFacebook = exports.SocialIcon = exports.SocialIconLink = exports.TitleWrapper = exports.SocialLinksWrapper = exports.SocialIconsContainer = exports.SocialIconWrapper = void 0;
const polished_1 = require("polished");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.SocialIconWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2rem;
	height: 2rem;
	min-width: 2rem;
`;
exports.SocialIconsContainer = styled_components_1.default.div `
	justify-content: center;
	display: flex;
	gap: 1rem;
`;
exports.SocialLinksWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	text-align: center;
	margin: 1rem 0;
	padding: 1rem;
	border: 1px solid ${({ theme }) => theme.color.gray4};

	${(0, styled_breakpoints_1.up)('md')} {
		margin: 0 0 1rem;
	}
`;
exports.TitleWrapper = styled_components_1.default.div `
	color: ${props => props.theme.color.brand3};
	font-size: 1.25rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
`;
exports.SocialIconLink = styled_components_1.default.a `
	height: 100%;
	width: 100%;
	border-radius: 1rem;
	transition: 0.3s;
	background: ${({ theme }) => theme.color.brand1};
	:hover {
		background: ${({ theme }) => (0, polished_1.darken)(0.1, theme.color.white)};
	}
	svg {
		width: 1rem;
		color: ${({ theme }) => theme.color.white};
	}
`;
exports.SocialIcon = (0, styled_components_1.default)(elements_1.Icon) `
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
exports.SocialIconFacebook = (0, styled_components_1.default)(exports.SocialIcon) ``;
exports.SocialIconInstagram = (0, styled_components_1.default)(exports.SocialIcon) ``;
exports.SocialIconLinkedIn = (0, styled_components_1.default)(exports.SocialIcon) ``;
exports.SocialIconTwitter = (0, styled_components_1.default)(exports.SocialIcon) ``;
exports.SocialIconYoutube = (0, styled_components_1.default)(exports.SocialIcon) ``;
